export default __webpack_public_path__ + "984b3970071e4c7a54d4ef180818ea28.png";